<template>
    <el-container class="uaa_content">
      <el-header style="height:40px;  background-color: rgb(46,117,181);padding:0">
        <header_info/>
      </el-header>
      <el-container>
        <el-aside width="200px" style=" background-color:#545c64">
          <left_menu/>
        </el-aside>
        <el-main>
          <el-container>
            <el-header style="height: 35px">
              <content_nav/>
            </el-header>
            <el-main>
              <router-view></router-view>
            </el-main>
          </el-container>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
  import header_info from './header_info'
  import footer_text from './footer_text'
  import left_menu from './left_menu_pure'
  import content_nav from './content_nav'

  export default {
    name: "index",
    components: {
      header_info,
      footer_text,
      left_menu,
      content_nav
    }
  }
</script>


<style scoped>
  .uaa_content >>> .el-main{
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue